import WboTransportProvider
    from '@/components/common/ed-board/ed-board-tools/wbo-client/interfaces/wbo-transport-provider.interface';
import GenericQueue from '@/components/common/ed-board/ed-board-tools/wbo-client/util/generic-queue';
import {
    WboAnnotationDocumentMetadata,
    WboDelta,
    WboFetchResponse,
    WboMsg,
    WboRequestMessage,
    WboServerResponse
} from '@/components/common/ed-board/ed-board-tools/wbo-client/model/wbo-annotation.model';

/**
 * This class handles the sending and receiving of the operations to / from the WBO server. The details about the
 * transport are delegated to the WboTransportProvider.
 */
export default class WboCommandController {
    private transportProvider: WboTransportProvider;
    private incomingOps: GenericQueue<WboDelta>;
    private readonly boardName: string;

    /**
     * Construct a command controller that relies on a specific transport provider to send commands to the server and
     * receive responses.
     * @param transportProvider Object that handles the actual transport of the messages.
     * @param incomingOps Queue in which this object will write the deltas arriving from the server.
     * @param boardName Name of the board to which this controller is connected.
     */
    constructor(transportProvider: WboTransportProvider,
                incomingOps: GenericQueue<WboDelta>,
                boardName: string) {
        this.transportProvider = transportProvider;
        this.incomingOps = incomingOps;
        this.boardName = boardName;
    }

    subscribe(boardName: string, boardMetadata: WboAnnotationDocumentMetadata) {
        this.transportProvider.subscribe(boardName, boardMetadata);
    }


    broadcast(msg: WboMsg) {
        this.transportProvider.sendDelta({opType: 'broadcast', msg});
        
    }

    removeAllByUser(msg: WboMsg): Promise<WboServerResponse | undefined> {
        return this.sendWithAck({opType: 'removeAllByUser', msg});

    }

    async fetch(request: WboRequestMessage): Promise<WboFetchResponse> {
        return this.transportProvider.sendRequest(request);
    }

    listenRemoteMessages() {
        this.transportProvider.onMessage(delta =>  {
            if (delta.msg.board === this.boardName) {
                this.incomingOps.enqueue(delta);
            }
        });

    }

    send(wboDelta: WboDelta): void {
        this.transportProvider.sendDelta(wboDelta);
    }

    sendWithAck(wboDelta: WboDelta): Promise<WboServerResponse | undefined> {
        return this.transportProvider.sendDeltaWithAck(wboDelta);
    }

    close() {
        this.transportProvider.close();
    }

}